import { render, staticRenderFns } from "./OccupationReport.vue?vue&type=template&id=40083dcf&scoped=true&"
import script from "./OccupationReport.vue?vue&type=script&lang=js&"
export * from "./OccupationReport.vue?vue&type=script&lang=js&"
import style0 from "./OccupationReport.vue?vue&type=style&index=0&id=40083dcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40083dcf",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/workspace/components/Logo.vue').default})
